<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <div class="container">
      <nav class="navbar">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/logo.svg" alt="雁南时空科技 Logo" class="logo-img" />
            <div class="logo-text-group">
              <span class="logo-text">雁南时空科技</span>
              <span class="logo-subtitle">Yannan Space-Time Technology</span>
            </div>
          </router-link>
        </div>
        <div class="nav-menu" :class="{ 'nav-menu-open': menuOpen }">
          <router-link to="/" class="nav-item" @click.native="closeMenu">首页</router-link>
          <router-link to="/about" class="nav-item" @click.native="closeMenu">关于我们</router-link>
          <router-link to="/business" class="nav-item" @click.native="closeMenu">业务板块</router-link>
          <router-link to="/cases" class="nav-item" @click.native="closeMenu">成功案例</router-link>
          <router-link to="/news" class="nav-item" @click.native="closeMenu">新闻动态</router-link>
          <router-link to="/team" class="nav-item" @click.native="closeMenu">团队介绍</router-link>
          <router-link to="/join-us" class="nav-item" @click.native="closeMenu">加入我们</router-link>
          <router-link to="/contact" class="nav-item" @click.native="closeMenu">联系我们</router-link>
        </div>
        <div class="menu-toggle" @click="toggleMenu">
          <i class="el-icon-menu"></i>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isScrolled: false,
      menuOpen: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 100
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  &.header-scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;

    .logo {
      a {
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 12px;

        .logo-img {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        }

        .logo-text-group {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
        }

        .logo-text {
          font-size: 24px;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 1.2;
          background: linear-gradient(135deg, #1890ff, #52c41a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .logo-subtitle {
          font-size: 11px;
          color: #999;
          font-weight: 400;
          letter-spacing: 1px;
        }
      }
    }

    .nav-menu {
      display: flex;
      gap: 40px;
      align-items: center;

      .nav-item {
        color: #333;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        position: relative;
        transition: color 0.3s;
        padding: 5px 0;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #1890ff, #52c41a);
          transition: width 0.3s;
        }

        &:hover,
        &.router-link-active {
          color: #1890ff;

          &::after {
            width: 100%;
          }
        }
      }
    }

    .menu-toggle {
      display: none;
      font-size: 24px;
      cursor: pointer;
      color: #333;
    }
  }
}

@media (max-width: 768px) {
  .header {
    .navbar {
      .nav-menu {
        position: fixed;
        top: 80px;
        left: 0;
        right: 0;
        background: #fff;
        flex-direction: column;
        gap: 0;
        padding: 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        transform: translateY(-100%);
        opacity: 0;
        transition: all 0.3s;
        pointer-events: none;

        &.nav-menu-open {
          transform: translateY(0);
          opacity: 1;
          pointer-events: all;
        }

        .nav-item {
          width: 100%;
          padding: 15px 0;
          border-bottom: 1px solid #f0f0f0;
        }
      }

      .menu-toggle {
        display: block;
      }
    }
  }
}
</style>

